<div id="education" class="page-wrapper">

  <app-menu [activeMenuIndex]="5">
  </app-menu>

  <!--<div class="subheader-bar-wrapper">
    <div class="subheader-content">
      <a href="https://www.lsd-diagnostik-partner.de/" target="_blank">
        <div class="subheader-content-text">
          Ihr kostenfreies Testset!
        </div>
      </a>
    </div>
  </div>-->

  <div class="floating-chameleon">
  </div>

  <div class="content-icon">
    <img src="/assets/img/template/icon-education.svg" alt="Icon Bildung" />
  </div>

  <!-- <span class="icon-psycho ico page-intro apple"></span> -->

  <div class="title-wrapper">
    <h1>
      Education
    </h1>
		<h2 class="m-b-40">
			Morbus Fabry im Blick:<br>
      Aktuelles aus der Literatur
		</h2>
		<div class="title-description">
			Neue Erkenntnisse und spannende Forschungsergebnisse zu Morbus Fabry finden Sie in unserem Newsletter kurz und knapp zusammengestellt. Sie finden unter anderem folgende Themen:
		</div>
  </div>

  <div class="info-section m-t-0 m-b-10">
    <div class="wrapper-half-title-center">
      <div class="separator education"></div>
      <div class="info-section-title">
        Screening von Patienten mit chronischen Nierenerkrankungen in Japan auf M. Fabry
      </div>
    </div>
    <div class="wrapper-half-center">
      <p class="text-center">
        Die Prävalenz von M. Fabry bei Dialyse-Patienten wird in der Literatur mit 0–1,69% angegeben. In der Kohortenstudie von Nagata et al., 2021 wies von den 1.703 untersuchten dialysepflichtigen Patienten einer einen M. Fabry auf (Prävalenz 0,06%) auf. In der Kohorte der 419 Patienten mit CKD des Stadiums 1-5 wurden 2 Fabry-Patienten gefunden (Prävalenz 0,48%).
      </p>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-10">
    <div class="wrapper-half-title-center">
      <div class="separator education"></div>
      <div class="info-section-title">
        Ionenkanäle und Schmerz bei M. Fabry
      </div>
    </div>
    <div class="wrapper-half-center">
      <p class="text-center">
        In dieser Übersichtsarbeit von Weissmann et al., 2021 wurde eine Vielzahl von Studien in vitro und mit Tiermodellen zum Einfluss von Ionenkanälen auf den Schmerz bei M. Fabry ausgewertet. Untersucht wurden bislang unter anderem die spannungsabhängigen Natriumkanäle NaV1,7 und NaV1,8, die Transient-Rezeptorpotenzial-Kanäle TRPV1, TRPM8 oder TRPA1, spannungsabhängige Kalziumkanäle oder verschiedene Kalziumkanäle. Nach den bisherigen Befunden unterscheidet sich der Schmerz bei M. Fabry von anderen Small-Fiber-Neuropathien.
      </p>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-10">
    <div class="wrapper-half-title-center">
      <div class="separator education"></div>
      <div class="info-section-title">
        Jetzt für den Fabry-Newsletter anmelden!
      </div>
    </div>
  </div>

  <!--
    formControlName="lastName"
    [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }"
  -->

   <div class="info-section info-section-3 m-b-0">

    <div>
      <form>
        <div class="info-section-form-container">
          <div class="info-section-form-column">

            <div class="info-section-form-input-container">
              <div class="info-section-form-label">
                Anrede*
              </div>

              <input type="text"
                class="info-section-form-input-text"
              />
            </div>

            <div class="info-section-form-input-container">
              <div class="info-section-form-label">
                Titel
              </div>
              <input type="text"
                class="info-section-form-input-text"
              />
            </div>

            <div class="info-section-form-input-container">
              <div class="info-section-form-label">
                Vorname
              </div>
              <input type="text"
                class="info-section-form-input-text"
              />
            </div>

            <div class="info-section-form-input-container">
              <div class="info-section-form-label">
                Nachname*
              </div>
              <input type="text"
                class="info-section-form-input-text"
              />
            </div>

            <div class="info-section-form-input-container">
              <div class="info-section-form-label">
                Beruf
              </div>
              <input type="text"
                class="info-section-form-input-text"
              />
            </div>

            <div class="info-section-form-input-container">
              <div class="info-section-form-label">
                PLZ*
              </div>
              <input type="text"
                class="info-section-form-input-text"
              />
            </div>

            <div class="info-section-form-input-container">
              <div class="info-section-form-label">
                Ort*
              </div>
              <input type="text"
                class="info-section-form-input-text"
              />
            </div>

            <div class="info-section-form-input-container">
              <div class="info-section-form-label">
                Institution*
              </div>
              <input type="text"
                class="info-section-form-input-text"
              />
            </div>

            <div class="info-section-form-input-container">
              <div class="info-section-form-label">
                E-Mail-Adresse *
              </div>
              <input type="text"
                class="info-section-form-input-text"
              />
            </div>

            <div class="info-section-form-input-container">
              <input type="checkbox"
                class="info-section-form-input-checkbox"
                id="education-checkbox"
                />
              <label for="education-checkbox" class="info-section-form-label-2">
                Ich möchte Informationen zu aktuellen Studien, wissenschaftlichen Updates und Fortbildungsveranstaltungen zu Morbus Fabry regelmäßig per E-Mail erhalten sowie über Neuigkeiten und Angebote von Takeda informiert werden. Die Nutzerinteraktionen mit den E-Mails werden durch den Einsatz marktüblicher Technologien gemessen. Nähere Informationen dazu finde ich in den Datenschutzhinweisen von Takeda unter <a href="https://www.takeda-digital.de/datenschutz" target="_blank">Takeda-digital.de/Datenschutz</a>. Meine Einwilligung kann ich jederzeit ohne Angabe von Gründen gegenüber Takeda widerrufen. (ID=65)
              </label>
            </div>

            <div class="info-section-form-label-3">
              * Pflichtfeld
            </div>

          </div>
        </div>
      </form>
    </div>

    <div class="info-section-form-button">
      Anmelden
    </div>

  </div>

  <!-- <iframe class="mj-w-res-iframe" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://app.mailjet.com/widget/iframe/1Hev/Epw" width="100%"></iframe> -->

  <div class="info-section info-section-4 m-t-0 m-b-0">
    <div class="wrapper-half-title-center">
      <div class="separator education"></div>
      <div class="info-section-title">
        Mediathek
      </div>
    </div>

    <div class="info-section-container">
      <!-- <div class="info-section-block">
        <div class="info-section-block-image">
          <img src="/assets/img/template/icon_20_temp.png" />
        </div>
        <div class="info-section-block-title">
          Wir unterstützen Sie bei der Diagnose
        </div>
        <div class="info-section-block-text">
          Ein einfacher Bluttest ermöglicht eine frühzeitige und eindeutige Diagnose von Morbus Fabry. Um Sie im Verdachtsfall zu unterstützen, bietet Takeda ein kostenfreies Trockenblut-Testset an.
        </div>
      </div> -->


      <div class="info-section-block">
        <div class="info-section-block-image video-thumbs" style="height: 170px">
          <a href="https://www.rarediseasesacademy.de/veranstaltungen/" target="_blank">
            <div class="img-yt"></div>
            <img src="/assets/img/template/rare-diseases.png" style="border: 1px solid #84be43;" />
          </a>
        </div>
        <div class="info-section-block-title">
          Nicht verpassen: Veranstaltungen zu Seltenen Erkrankungen
        </div>
        <div class="info-section-block-text">
          Aktuelle und zukünftige Veranstaltungen zu Morbus Fabry und weiteren Seltenen Erkrankungen finden Sie in unserem Kalender.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image" style="height: 170px">
          <iframe width="300" height="168" src="https://www.youtube.com/embed/ugzDdr_SI6M" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="border: 1px solid #84be43;"></iframe>
        </div>
        <div class="info-section-block-title">
          Der lange Weg zur Diagnose Morbus Fabry
        </div>
        <div class="info-section-block-text">
          Max hat es geschafft. Endlich hat er eine Diagnose.
          Hinter ihm liegen viele Jahre, in denen er bei zahlreichen Ärzten war.
          Denn Max leidet bereits seit seiner Kindheit unter brennenden Schmerzen in den Händen und Füßen, Bauchschmerzen und hat rote Punkte auf der Haut.
          Der Film gibt einen kurzen Einblick, warum es so schwierig ist, eine seltene Erkrankung wie Morbus Fabry zu diagnostizieren.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image" style="height: 170px">
          <!-- width="560" height="315" -->
          <iframe width="300" height="168" src="https://www.youtube.com/embed/36EinEUEoiY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen  style="border: 1px solid #84be43;"></iframe>
          <!--<a href="https://www.youtube.com/embed/36EinEUEoiY" target="_blank">
            <img src="/assets/img/template/thumbnail-kardiologie-3.png" />
          </a>-->
        </div>
        <div class="info-section-block-title">
          Wann sollte in der Kardiologie an Morbus Fabry gedacht werden?
        </div>
        <div class="info-section-block-text">
          EKG und Echokardiografie können bereits erste Hinweise
          auf eine seltene Ursache, wie die genetisch-bedingte
          Speicherkrankheit Morbus Fabry, geben.
          Gezielte Fragen an den Patienten können die Verdachtsdiagnose erhärten.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image" style="height: 170px">
          <iframe width="300" height="168" src="https://www.youtube.com/embed/e2ftoowxRtc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen  style="border: 1px solid #84be43;"></iframe>
        </div>
        <div class="info-section-block-title">
          Wann sollte in der Neurologie an Morbus Fabry gedacht werden?
        </div>
        <div class="info-section-block-text">
          Die Speicherkrankheit Morbus Fabry zeichnet sich
          durch die Vielfalt an Symptomen aus.
          Dies ist eine Herausforderung für den Arzt,
          bei bestimmten Auffälligkeiten an die seltene genetische Erkrankung zu denken.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image" style="height: 170px">
          <iframe width="300" height="168" src="https://www.youtube.com/embed/qwX_U0wNsAU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="border: 1px solid #84be43;"></iframe>
        </div>
        <div class="info-section-block-title">
          Wann sollte in der Nephrologie an Morbus Fabry gedacht werden
        </div>
        <div class="info-section-block-text">
          Albuminurie/Proteinurie, chronische Niereninsuffizienz. Das sind klassische Themen in der Nephrologie. Sie bringen gleichermaßen eine Herausforderung mit sich. Denn hinter eine unklaren Proteinurie könnte als Ursache auch die seltene Erkrankung Morbus Fabry stecken.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image" style="height: 170px">
          <iframe width="300" height="168" src="https://www.youtube.com/embed/K0pYqJo1TxY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="border: 1px solid #84be43;"></iframe>
        </div>
        <div class="info-section-block-title">
          Wann sollte in der Pädiatrie an Morbus Fabry gedacht werden
        </div>
        <div class="info-section-block-text">
          Je früher die Diagnose einer seltenen Erkrankung gestellt wird, desto eher können Maßnahmen zum Schutz der Organe und Organsysteme eingeleitet werden. Eine ganz entscheidende Rolle spielt dabei die Kinderheilkunde.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image video-thumbs" style="height: 170px">
          <a href="https://vimeo.com/496946255/a5f7a02e62" target="_blank">
            <div class="img-yt"></div>
            <img src="/assets/img/template/video-thumbnail-webinar-neurologische.jpg" style="border: 1px solid #84be43;" />
          </a>
        </div>
        <div class="info-section-block-title">
          Neurologische und neuroradiologische Merkmale des Morbus Fabry
        </div>
        <div class="info-section-block-text">
          Für die frühzeitige Diagnose Morbus Fabry in der Neurologie zeigt Dr. Amir Golsari die typischen neurologischen und neuroradiologischen Merkmale auf.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image video-thumbs" style="height: 170px">
          <a href="https://vimeo.com/537629868/93cc5b05d1" target="_blank">
            <div class="img-yt"></div>
            <img src="/assets/img/template/video-thumbnail-webinar-seltene.jpg" style="border: 1px solid #84be43;" />
          </a>
        </div>
        <div class="info-section-block-title">
          Seltene Ursachen häufiger Beschwerden: Bauchschmerzen in der Pädiatrie
        </div>
        <div class="info-section-block-text">
          Bauchschmerzen als typisches Symptom in der Kindheit können verschiedene Ursachen haben. Dr. Johannes Krämer erläutert, wann Sie bei Bauchschmerzen an Morbus Fabry denken sollten.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image video-thumbs" style="height: 170px">
          <a href="https://vimeo.com/544890723/21f2ffd9c9" target="_blank">
            <div class="img-yt"></div>
            <img src="/assets/img/template/video-thumbnail-masterclas-fruhzeitige.jpg" style="border: 1px solid #84be43;" />
          </a>
        </div>
        <div class="info-section-block-title">
          Frühzeitige Diagnostik und Progression bei Morbus Fabry
        </div>
        <div class="info-section-block-text">
          Warum eine frühzeitige Diagnose bei Morbus Fabry wichtig ist und wie Sie rechtzeitig die Verdachtsdiagnose stellen können, erläutert Dr. Christina Lampe mit praxisnahen Beispielen.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image video-thumbs" style="height: 170px">
          <a href="https://vimeo.com/546373134/23c1422754" target="_blank">
            <div class="img-yt"></div>
            <img src="/assets/img/template/video-thumbnail-masterclas-literaturreview.jpg" style="border: 1px solid #84be43;" />
          </a>
        </div>
        <div class="info-section-block-title">
          Literaturreview: Biomarker bei M. Fabry
        </div>
        <div class="info-section-block-text">
          Biomarker spielen eine entscheidende Rolle in der frühzeitigen Diagnose von Morbus Fabry. Prof. Dr. Monica Patten-Hameln präsentiert aktuell publizierte Erkenntnisse.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image video-thumbs" style="height: 170px">
          <a href="https://vimeo.com/496952971/c7bd87839a" target="_blank">
            <div class="img-yt"></div>
            <img src="/assets/img/template/Webinar_Paediatrie_Diagnostik_Startslide.jpg" style="border: 1px solid #84be43;" />
          </a>
        </div>
        <div class="info-section-block-title">
          Die Nadel im Heuhaufen: effiziente Diagnostik von Stoffwechselerkrankungen
        </div>
        <div class="info-section-block-text">
          Sind Ihnen in der Praxis schon einmal Patienten begegnet, bei denen die Diagnose lange Zeit unklar war? Vielleicht waren darunter auch Patienten mit einer seltenen Erkrankung, bei denen die Diagnose erst durch Umwege gestellt werden konnte.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image video-thumbs" style="height: 170px">
          <a href="https://vimeo.com/518556389/e0dd15ae52" target="_blank">
            <div class="img-yt"></div>
            <img src="/assets/img/template/video-thumbnail-webcast-tipps-und-tricks.jpg" style="border: 1px solid #84be43;" />
          </a>
        </div>
        <div class="info-section-block-title">
          „Hätten Sie's gewusst?“ Tipps und Tricks für eine frühzeitige Diagnose seltener Erkrankungen
        </div>
        <div class="info-section-block-text">
          Je früher die Diagnose einer seltenen Erkrankung gestellt wird, desto eher können Maßnahmen zum Schutz der Organe und Organsysteme eingeleitet werden. Eine ganz entscheidende Rolle spielt dabei die Kinderheilkunde.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image video-thumbs" style="height: 170px">
          <a href="https://vimeo.com/544888405/48ba53e279" target="_blank">
            <div class="img-yt"></div>
            <img src="/assets/img/template/video-thumbnail-guess-who.jpg" style="border: 1px solid #84be43;" />
          </a>
        </div>
        <div class="info-section-block-title">
          Guess who! Interaktiv Fälle seltener Augenerkrankungen live diskutiert
        </div>
        <div class="info-section-block-text">
          Anhand von Fallbeispielen erläutern Prof. Martin Spitzer und Dr. Simon Dulz typische Auffälligkeiten von seltenen Augenerkrankungen, wie z.B. Morbus Fabry.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image" style="height: 170px">
          <iframe width="300" height="168" src="https://www.youtube.com/embed/oJjld0je6po" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen  style="border: 1px solid #84be43;"></iframe>
        </div>
        <div class="info-section-block-title">
          Von der Bildgebung zur Diagnose Morbus Fabry
        </div>
        <div class="info-section-block-text">
          Die hypertrophe Kardiomyopathie (HCM) ist eine
          mögliche Ursache einer linksventrikulären Hypertrophie (LVH).
          Speicherkrankheiten, wie Amyloidose oder Morbus Fabry,
          sollten ebenso als mögliche Differenzialdiagnose
          in Betracht gezogen werden.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image" style="height: 170px">
          <iframe width="300" height="168" src="https://www.youtube.com/embed/-w3ez-RdYzo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen  style="border: 1px solid #84be43;"></iframe>
        </div>
        <div class="info-section-block-title">
          Diagnosen müssen nicht selten sein
        </div>
        <div class="info-section-block-text">
          Die lysosomalen Speicherkrankheiten (LSD) Morbus Fabry,
          Morbus Gaucher und Morbus Hunter sind genetische Stoffwechselerkrankungen,
          die aufgrund der stark variierenden Symptome leicht zu übersehen sind.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image video-thumbs" style="height: 170px">
          <a href="https://www.rarediseasesacademy.de/veranstaltungen/" target="_blank">
            <div class="img-yt"></div>
            <img src="/assets/img/template/rare-diseases-academy.png" style="border: 1px solid #84be43;" />
          </a>
        </div>
        <div class="info-section-block-title">
          Rare Diseases Academy
        </div>
        <div class="info-section-block-text">
          In der RARETHEK der RARE DISEASES ACADEMY finden Sie weitere Fortbildungsvideos zu Morbus Fabry und anderen Seltenen Erkrankungen.
        </div>
      </div>

      <div class="info-section-block">
        <div class="info-section-block-image video-thumbs" style="height: 170px">
          <a href="https://www.rarediseasesacademy.de/podcast/reihe/unglaublich-krank/" target="_blank">
            <div class="img-yt"></div>
            <img src="/assets/img/template/thumbnail-podcast-unglaubich-krank.jpg" style="border: 1px solid #84be43;" />
          </a>
        </div>
        <div class="info-section-block-title">
          Podcast – Unglaublich krank
        </div>
        <div class="info-section-block-text">
          Im Podcast begeben sich der anerkannte Experte für Seltene Erkrankungen Dr. Martin Mücke und die an Gesundheitsthemen interessierte Schauspielerin und Regisseurin Esther Schweins auf die Fährte rätselhafter Krankheiten. In jeder Episode widmet sich das ungewöhnliche Duo einem dramatischen Fall, der mit beunruhigenden Symptomen beginnt und mit einer lebensverändernden Diagnose endet.
        </div>
      </div>

      <div class="info-section-block">
      </div>
      <!--<div class="info-section-block">
        <div class="info-section-block-image video-thumbs" style="height: 170px">
          <a href="https://vimeo.com/537629868/93cc5b05d1" target="_blank">
            <div class="img-yt"></div>
            <img src="/assets/img/template/video-thumbnail-rd-webup-padiatrie.jpg" style="border: 1px solid #84be43;" />
          </a>
        </div>
        <div class="info-section-block-title">
          Seltene Ursachen häufiger Beschwerden: Bauchschmerzen in der Pädiatrie
        </div>
        <div class="info-section-block-text">
          Bauchschmerzen als typisches Symptom in der Kindheit können verschiedene Ursachen haben. Dr. Johannes Krämer erläutert, wann Sie bei Bauchschmerzen an Morbus Fabry denken sollten.
        </div>
      </div>-->

      <!--<div class="info-section-block">
        <div class="info-section-block-image video-thumbs" style="height: 170px">
          <a href="https://vimeo.com/546371345/dad34abc43" target="_blank">
            <div class="img-yt"></div>
            <img src="/assets/img/template/video-thumbnail-masterclas-worldsymposium.jpg" style="border: 1px solid #84be43;" />
          </a>
        </div>
        <div class="info-section-block-title">
          Update WORLDSymposium 2021
        </div>
        <div class="info-section-block-text">
          Die Highlights bzgl. Morbus Fabry vom WORLDSymposium 2021 hat Dr. Ali Tunç Tuncel kurz und knapp zusammengefasst.
        </div>
      </div>-->

<!--      <div class="info-section-block">
      </div>-->
    </div>
  </div>

  <app-footer>
  </app-footer>

</div>
